<template>
    <div class="back-body">
        <div class="back-left">
            <div class="back-icon" @click="backAgo">
                <img src="../../assets/imgs/backBlack.png" alt="">
            </div>
            <div v-if="goto">
                <div @click="goto(goparam)" class="back-msg">{{msg}}</div>
            </div>
            <div v-if="!go">
                <div class="back-msg">{{msg}}</div>
            </div>
        </div>
        <div class="back-right">
            <div class="my-book"  @click="goMybook">{{$t("shelf")}}</div>
            <div class="back-index" @click="go.backIndex">
                <img src="../../assets/imgs/home-back.png" alt="">
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "readback",
        props:['msg','goto','goparam'],
        methods:{
            //返回上一页
            backAgo(){
                this.$router.back(-1)
            },
            
            //跳转至我的书架
            goMybook(){
                this.go.goMybook();
            }
        }
    }
</script>

<style scoped>
    .back-body{
        width: 100%;
        height: 1rem;
        background: #ffffff;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 0.01rem solid #e6e6e6;
    }
    .back-left,.back-right{
        display: flex;
        align-items: center;
    }
    .back-icon{
        width:0.19rem;
        height: 0.32rem;
    }
    .back-icon img{
        width:0.19rem;
        height: 0.32rem;
        display: block;
    }
    .back-index{
        width:0.44rem;
        height: 0.42rem;
    }
    .back-index img{
        width: 0.44rem;
        height: 0.42rem;
        display: block;
    }
    .back-msg{
        font-size: 0.32rem;
        line-height: 0.32rem;
        color: #666666;
        font-weight: 700;
        padding-left: 0.2rem;
    }
    .my-book{
        width: 0.86rem;
        height: 0.42rem;
        background:#ff1f4f;
        font-size: 0.28rem;
        line-height: 0.42rem;
        border-radius: 0.04rem;
        color: #fff;
        text-align: center;
        margin-right: 0.4rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/readback.vue